/* eslint-disable prettier/prettier */
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from '@material-ui/core';
import ModalActions from 'components/ModalActions';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listNutrorCourses } from 'store/Orbita/NutrorCourse/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  courses: any[];
  packages: any[];
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  nutror?: any;
}

interface IStates {
  selected: any;
  directAccess: boolean;
  inputSelected: any;
}

class Nutror extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.props.dispatch(listNutrorCourses());
    this.state = {
      directAccess: props.nutror && props.nutror.direct_access,
      selected: '',
      inputSelected: ''
    };
  }
  handleChange = (event: any) => {
    const { courses, packages } = this.props;
    const hash = event.target.value;
    let newSelected;
    let selectedCourse = courses && courses.length && courses.filter((item: any) => item.hash === hash)[0];
    let selectedPackage = packages && packages.length && packages.filter((item: any) => item.hash === hash)[0];
    if (selectedCourse) {
      newSelected = selectedCourse;
      newSelected.nutror_id = selectedCourse.id;
      newSelected.type = 'C';
    } else if (selectedPackage) {
      newSelected = selectedPackage;
      newSelected.nutror_id = selectedPackage.id;
      newSelected.type = 'P';
    } else {
      toast.error('Ocorreu um erro ao tentar selecionar o curso ou pacote do nutror');
      return;
    }
    newSelected.nutror_hash = hash;
    newSelected.method_id = '24';
    newSelected.nutror_name = newSelected.title;
    this.setState({ selected: newSelected, inputSelected: hash });
  };

  handleOk = () => {
    const onOk = this.props.onOk;
    const { selected, directAccess } = this.state;

    if (selected) {
      if (onOk) {
        if (this.props.nutror && (selected.hash === this.props.nutror.hash) && (directAccess === this.props.nutror.direct_access)) {
          return this.props.onClose();
        }

        selected.new = true;
        selected.direct_access = directAccess;

        onOk(selected, this.props.nutror);
        if (!this.props.nutror) {
          toast.success(`Item ${selected.title} adicionado com sucesso!`);
        }
        this.setState({ selected: '', inputSelected: '' });
      }
    } else {
      toast.warn('Por favor selecione um curso ou pacote');
    }
  };
  componentDidUpdate(prevProps: IProps) {
    if (prevProps !== this.props && this.props.nutror) {
      this.setState({ selected: this.props.nutror, inputSelected: this.props.nutror.nutror_hash });
    }
  }
  render() {
    const { courses, packages, isModal, open, onClose } = this.props;
    const { directAccess } = this.state;

    const content = (
      <form>
        <Grid container justify={'center'}>
          <Grid item xs={12}>
            <InputLabel shrink htmlFor='nutror'>
              Selecione um curso ou pacote
            </InputLabel>
            <Select
              input={<Input />}
              disableUnderline
              inputProps={{ disableUnderline: true }}
              value={this.state.inputSelected}
              onChange={this.handleChange}
              fullWidth
            >
              {courses &&
                courses.length &&
                courses.map((course: any) => (
                  <MenuItem key={`course-${course.hash}`} value={course.hash}>
                    {course.title}
                  </MenuItem>
                ))}
              {courses && courses.length <= 0 && <MenuItem disabled>{'Não há cursos cadastrados'}</MenuItem>}

              <Divider />
              {packages &&
                packages.length &&
                packages.map((pck: any) => (
                  <MenuItem key={`package-${pck.hash}`} value={pck.hash}>
                    {pck.title}
                  </MenuItem>
                ))}
              {packages && packages.length <= 0 && <MenuItem disabled>{'Não há pacotes cadastrados'}</MenuItem>}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Switch value='allow-direct-access' />}
              checked={directAccess}
              onChange={(e: any) => this.setState({ directAccess: e.target.checked })}
              label='Habilitar acesso direto na página de obrigado.'
            />
          </Grid>
          <div className='m16' />
          <Grid item xs={12}>
            <strong>Novo por aqui? Crie um curso no Nutror</strong>
            <p>
              O Nutror é nossa plataforma de membros, com ele você pode criar cursos e grupos de assinatura. Acesse o{' '}
              <a href='https://my.nutror.com/cursos' target='_blank' rel='noopener noreferrer'>
                link
              </a>{' '}
              para criar o curso!
            </p>
          </Grid>
        </Grid>
      </form>
    );
    return (
      <div>
        {isModal ? (
          <ModalActions buttonOk='Salvar' title={'Entrega de Conteúdo'} open={open} onClose={onClose} onOk={this.handleOk}>
            {content}
          </ModalActions>
        ) : (
          <Card>
            <CardHeader
              title='Entrega de Conteúdo'
              action={
                <IconButton>
                  <Icon>clear</Icon>
                </IconButton>
              }
            />
            <CardContent>{content}</CardContent>
          </Card>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    courses: state.orbita.NutrorCourse.list.courses,
    packages: state.orbita.NutrorCourse.list.packages
  };
}

export default connect(mapStateToProps)(Nutror);
